/* unplugin-vue-components disabled */import { render } from "./AskVideoGz.vue?vue&type=template&id=96f6df0c&scoped=true"
import script from "./AskVideoGz.vue?vue&type=script&lang=js"
export * from "./AskVideoGz.vue?vue&type=script&lang=js"

import "./AskVideoGz.vue?vue&type=style&index=0&id=96f6df0c&lang=scss&scoped=true"

import exportComponent from "C:\\Users\\Public\\object\\xvideos-frontend\\mysex\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-96f6df0c"]])

export default __exports__